var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpDeletePhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4375 9.25C7.98877 9.25 7.625 9.61377 7.625 10.0625V10.3333C7.625 10.6325 7.86751 10.875 8.16667 10.875C8.46582 10.875 8.70833 11.1175 8.70833 11.4167V14.125C8.70833 15.9199 10.1634 17.375 11.9583 17.375H13.0417C14.8366 17.375 16.2917 15.9199 16.2917 14.125V11.4167C16.2917 11.1175 16.5342 10.875 16.8333 10.875C17.1325 10.875 17.375 10.6325 17.375 10.3333V10.0625C17.375 9.61377 17.0112 9.25 16.5625 9.25H8.4375ZM11.3958 11.9583C11.3958 11.8203 11.2839 11.7083 11.1458 11.7083C11.0078 11.7083 10.8958 11.8203 10.8958 11.9583V14.6667C10.8958 14.8047 11.0078 14.9167 11.1458 14.9167C11.2839 14.9167 11.3958 14.8047 11.3958 14.6667V11.9583ZM14.1042 11.9583C14.1042 11.8203 13.9922 11.7083 13.8542 11.7083C13.7161 11.7083 13.6042 11.8203 13.6042 11.9583V14.6667C13.6042 14.8047 13.7161 14.9167 13.8542 14.9167C13.9922 14.9167 14.1042 14.8047 14.1042 14.6667V11.9583Z",
    fill: "#05073C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4537 7.82574C11.5155 7.76815 11.6515 7.71726 11.8407 7.68097C12.0299 7.64467 12.2617 7.625 12.5002 7.625C12.7386 7.625 12.9705 7.64467 13.1597 7.68097C13.3489 7.71726 13.4849 7.76815 13.5466 7.82574",
    stroke: "#05073C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpDeletePhoto);
export default __webpack_public_path__ + "static/media/cp-delete-photo.89e0055559ffd07f96a126b712d81529.svg";
export { ForwardRef as ReactComponent };